const mediaItems = [
  {
    title: '深度解析：娱乐圈合约纠纷背后',
    duration: '15:28',
    views: '12.8万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20style%20image%20of%20a%20legal%20document%20with%20warm%20crimson%20spotlight%2C%20abstract%20courtroom%20atmosphere%2C%20cinematic%20lighting%2C%20editorial%20style%2C%20clean%20composition%2C%20play%20button%20aesthetic&width=640&height=380&seq=media-01&orientation=landscape',
  },
  {
    title: '全程回顾：顶流男星密会事件时间线',
    duration: '22:15',
    views: '9.6万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20timeline%20visualization%20with%20warm%20amber%20lighting%2C%20abstract%20clock%20and%20calendar%20elements%2C%20mysterious%20noir%20atmosphere%2C%20editorial%20thumbnail%20style%2C%20clean%20composition%2C%20cinematic%20mood&width=640&height=380&seq=media-02&orientation=landscape',
  },
  {
    title: '独家揭秘：直播带货翻车内幕',
    duration: '18:42',
    views: '8.3万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20streaming%20studio%20with%20warm%20crimson%20and%20amber%20ring%20light%2C%20abstract%20product%20scattered%20composition%2C%20digital%20screen%20glare%2C%20investigative%20journalism%20aesthetic%2C%20editorial%20style%2C%20clean%20background&width=640&height=380&seq=media-03&orientation=landscape',
  },
  {
    title: '圆桌讨论：明星人设崩塌全纪录',
    duration: '30:10',
    views: '6.9万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20round%20table%20discussion%20scene%20with%20warm%20crimson%20ambient%20lighting%2C%20abstract%20silhouettes%2C%20spotlight%20effects%2C%20talk%20show%20atmosphere%2C%20editorial%20thumbnail%20style%2C%20clean%20composition%2C%20cinematic%20mood&width=640&height=380&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">视频深扒</h2>
              <p className="text-sm text-foreground-600 mt-1">精彩视频深度解析</p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                      <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors w-6 h-6 flex items-center justify-center ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2">{item.views}次播放</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}